import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-info-blocks")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-info-blocks")),
  head: () => ({
    meta: [
      { title: "بلوك المعلومات (ديسكتوب) · Admin · Lecmo" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
